import { EtaLocation } from '@/feature/eta'

import styles from '../Eta.module.css'

export const CustomLocationFrom = ({ etaLocation }: { etaLocation: EtaLocation }) => (
  <div className={styles.customLocationFrom}>
    <div className={styles.locationFromContent}>
      <div className={styles.customAddress}>
        {etaLocation.address.split(',').slice(0, 2).join(',')}
      </div>
    </div>
    <div className={styles.customLatLng}>
      {etaLocation.latitude.toFixed(6)}, {etaLocation.longitude.toFixed(6)}
    </div>
  </div>
)

